import { createVanIconComponent } from "./van"

const Eye = createVanIconComponent("eye")
export default Eye
